module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/file-minus-dd6dccf21fe913ea5ccf69287a49f052.svg";